import { useAtom } from 'jotai';
import { FilterChip } from 'common/components/FilterChip/FilterChip';
import { productCodesFilterAtom } from 'atoms/filters/rsim-products';

export const RSimProductCodesChips = () => {
  const [productCodes, setProductCodes] = useAtom(productCodesFilterAtom);

  const onClear = (id: string | null) => {
    setProductCodes((currentProductCodes) =>
      currentProductCodes.filter((productCode) => productCode !== id),
    );
  };

  return (
    <>
      {productCodes.map((productCode) => {
        if (productCode === null) {
          return (
            <FilterChip
              key={productCode}
              text="Product Code: blank"
              onClose={() => {
                onClear(productCode);
              }}
            />
          );
        }

        return (
          <FilterChip
            key={productCode}
            text={`Product Code: ${productCode}`}
            onClose={() => {
              onClear(productCode);
            }}
          />
        );
      })}
    </>
  );
};
